module.exports = __webpack_public_path__ + "static/media/múfasa.5f70009e.svg";